import m from 'mithril';
import { Button } from './Buttons';

export const Footer: m.Component = {
    view() {
        return m('footer', { class: 'mt-auto pt-16 pb-8 border-t transition-colors duration-500 border-[var(--color-border)] bg-[var(--color-surface)]/20 shadow-[0_-10px_40px_-10px_rgba(0,0,0,0.02)]' }, [
            m('div', { class: 'max-w-screen-xl mx-auto px-6 lg:px-8' }, [
                // Top Grid
                m('div', { class: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16' }, [
                    // Brand / Newsletter Column
                    m('div', { class: 'lg:col-span-2 space-y-4' }, [
                        m('p', { class: 'text-2xl font-black tracking-widest bg-clip-text text-transparent bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] inline-block mb-3' }, 'KHALID'),
                        m('p', { class: 'text-sm opacity-70 font-medium max-w-sm leading-relaxed mb-6' }, 'Health & Joy, Delivered to You. The premium destination for specialized children\'s medicines, vitamins, and educational toys.'),
                        m('div', { class: 'pt-2 flex flex-col sm:flex-row gap-2' }, [
                            m('input', { 
                                type: 'email', 
                                placeholder: 'Enter your email for updates', 
                                class: 'px-4 py-2.5 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-base)] text-sm w-full max-w-xs focus:border-[var(--color-primary)] focus:ring-1 focus:ring-[var(--color-primary)] outline-none transition-all shadow-sm'
                            }),
                            m(Button, { size: 'sm', class: 'px-6 shadow-md' }, 'Subscribe')
                        ])
                    ]),
                    // Shop Column
                    m('div', { class: 'flex flex-col space-y-3' }, [
                        m('h4', { class: 'font-black uppercase tracking-widest text-[var(--color-text-base)] text-[10px] mb-2 opacity-50' }, 'Shop'),
                        ...['All Products', 'Electronics', 'Clothing', 'Beauty', 'Toys & Kids'].map(link => 
                            m('a', { href: '#', class: 'block text-sm font-semibold opacity-70 hover:opacity-100 hover:text-[var(--color-primary)] transition-transform hover:translate-x-1 w-max' }, link)
                        )
                    ]),
                    // Support Column
                    m('div', { class: 'flex flex-col space-y-3' }, [
                        m('h4', { class: 'font-black uppercase tracking-widest text-[var(--color-text-base)] text-[10px] mb-2 opacity-50' }, 'Support'),
                        ...['Contact Us', 'FAQs', 'Shipping & Returns', 'Privacy & Terms'].map(link => 
                            m('a', { href: '#', class: 'block text-sm font-semibold opacity-70 hover:opacity-100 hover:text-[var(--color-primary)] transition-transform hover:translate-x-1 w-max' }, link)
                        )
                    ])
                ]),
                // Bottom Flex Row
                m('div', { class: 'pt-8 border-t border-[var(--color-border)]/50 flex flex-col md:flex-row items-center justify-between gap-6' }, [
                    m('p', { class: 'text-[10px] font-bold opacity-40 uppercase tracking-widest' }, '© 2026 KHALID Kids & Care. All rights reserved.'),
                    // Social Links
                    m('div', { class: 'flex items-center gap-3' }, 
                        ['facebook', 'twitter', 'instagram', 'youtube'].map(network => 
                            m('a', { href: '#', class: 'hover-spring w-10 h-10 rounded-full border border-[var(--color-border)]/50 bg-[var(--color-surface)] shadow-sm flex items-center justify-center opacity-70 hover:opacity-100 hover:border-[var(--color-primary)] hover:text-[var(--color-primary)] transition-all' },
                                m('iconify-icon', { icon: `lucide:${network}`, class: 'text-[1.2em]' })
                            )
                        )
                    )
                ])
            ])
        ]);
    }
};
